
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"4.5 4.5 15 15","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke-width":"1.3","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M10.41 9c.455 0 .844.136 1.164.408.321.273.543.6.665.984h2.784a.45.45 0 01.338.145c.093.098.139.216.139.355v.216a.494.494 0 01-.14.354.45.45 0 01-.337.146h-.366v.892a.494.494 0 01-.14.354.45.45 0 01-.337.146h-.048a.45.45 0 01-.338-.146.494.494 0 01-.14-.354v-.892H12.24a2.11 2.11 0 01-.665.984c-.32.272-.709.408-1.165.408a1.8 1.8 0 01-1.352-.583A1.976 1.976 0 018.5 11c0-.556.186-1.028.557-1.417A1.8 1.8 0 0110.409 9zm0 1.19a.755.755 0 00-.563.232.795.795 0 00-.227.578c0 .23.076.423.227.578a.755.755 0 00.563.232.755.755 0 00.563-.232A.795.795 0 0011.2 11a.795.795 0 00-.227-.578.755.755 0 00-.563-.232z","fill":"currentColor","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M8.143 6h7.821c1.184 0 2.143.96 2.143 2.143v5.678c0 1.184-.96 2.143-2.143 2.143H12.67L9.7 18.562a.536.536 0 01-.888-.403v-2.195h-.67A2.143 2.143 0 016 13.821V8.143C6 6.959 6.96 6 8.143 6z","stroke":"currentColor","stroke-width":"1.4","stroke-linejoin":"round"}})])])
          )
        }
      }
    